import { render, staticRenderFns } from "./CourseQA.vue?vue&type=template&id=fdbedbbe&scoped=true"
import script from "./CourseQA.vue?vue&type=script&lang=ts"
export * from "./CourseQA.vue?vue&type=script&lang=ts"
import style0 from "./CourseQA.vue?vue&type=style&index=0&id=fdbedbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbedbbe",
  null
  
)

export default component.exports